import { Link } from "react-router-dom";
import { OWNER_NAME } from "@/data/content";

const COLUMNS = [
  {
    title: "Product",
    links: [
      { label: "Features", href: "/#features" },
      { label: "Pricing", href: "/#pricing" },
      { label: "What's new", href: "/changelog", internal: true },
      { label: "Roadmap", href: "/roadmap", internal: true },
    ],
  },
  {
    title: "For Brokerages",
    links: [
      { label: "Team dashboard", href: "/#product" },
      { label: "Seat management", href: "/#pricing" },
      { label: "Enterprise plans", href: "mailto:hello@chateaux.ai" },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "Support", href: "mailto:support@chateaux.ai" },
      { label: "Blog", href: "/blog", internal: true },
      { label: "Sample listing", href: "/download", internal: true },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy Policy", href: "/legal/privacy", internal: true },
      { label: "Terms of Service", href: "/legal/terms", internal: true },
      { label: "Cookie Policy", href: "/legal/cookies", internal: true },
      { label: "Data Deletion", href: "/legal/data-deletion", internal: true },
      { label: "Acceptable Use", href: "/legal/acceptable-use", internal: true },
    ],
  },
];

const LinkItem = ({ link }) => {
  const cls = "text-sm text-ink/55 hover:text-coral transition-colors duration-300";
  if (link.internal) return <Link to={link.href} className={cls} data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}>{link.label}</Link>;
  return <a href={link.href} className={cls} data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}>{link.label}</a>;
};

export const Footer = () => (
  <footer className="bg-bone border-t border-ink/10 pt-20 pb-10" data-testid="footer">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
        {COLUMNS.map((col) => (
          <div key={col.title}>
            <h4 className="text-xs uppercase tracking-[0.15em] text-ink/50 mb-5">{col.title}</h4>
            <ul className="space-y-3">
              {col.links.map((l) => (
                <li key={l.label}>
                  <LinkItem link={l} />
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="mt-20 border-t border-ink/10 pt-8 flex flex-col md:flex-row items-start md:items-end justify-between gap-6">
        <div className="font-serif text-6xl md:text-8xl tracking-tight text-ink leading-none">
          Chateaux
        </div>
        <p className="text-xs text-ink/50 max-w-sm md:text-right">
          © 2026 Chateaux. Operated by {OWNER_NAME} (sole proprietor). All rights reserved.
        </p>
      </div>
    </div>
  </footer>
);
